import Vue from 'vue';
import store from './store/store';
import VueRouter from 'vue-router';

import routes from './routes/index';
import EventsFeed from './EventsFeed.vue';

Vue.use(VueRouter);

const router = new VueRouter({
  base: '/events',
  mode: 'history',
  routes
});

document.addEventListener('DOMContentLoaded', (e) => {
  const el = '#events-feed';
  if (!document.querySelector(el)) return false;
  new Vue({
    store,
    router,
    components: {
      EventsFeed
    }
  }).$mount(el);
});

export { router };
